/* eslint-disable no-async-promise-executor */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { PF_CONFIG_SERVER_URL } from "../Constants";
import { IUser, ProgramCertificate } from "@interfaces/Interfaces";
import RemoteDataController from "./RemoteDataController";

export const sendCertificateVerificationRequest = async (params: {
  user: IUser;
  trainerName: string;
  trainerEmail: string;
  certificate: ProgramCertificate;
  certificateData: {
    date: string;
    programID: string;
    certificateID: string;
  };
}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const url = PF_CONFIG_SERVER_URL + "/email/send-certificate-verification-email";

      const body = {
        contactID: params.user.userData.contactID,
        userName: params.user.name,
        token: params.user.token,
        trainerName: params.trainerName,
        trainerEmail: params.trainerEmail,
        certificate: params.certificate,
        certificateData: params.certificateData,
      };

      const response: Response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response) {
        const json = await response.json();

        if (json.success) {
          resolve(true);
        } else {
          reject(json.message || json.error);
        }
      } else {
        reject("The server didn't respond");
      }
    } catch (error: any) {
      console.log(error);
      RemoteDataController.logError(error);
      reject("An error occurred when requesting verification");
    }
  });
};
